<ng-container>
  <header class="header">
    <div class="header-info">
      <div [style.backgroundColor]="loanOfficer$.headerColor" class="header-info-top">
        <div class="header-info-headers">
          <h3 [ngStyle]="{fontSize:fontSize}">
            {{ loanOfficer$.firstName }} {{ loanOfficer$.lastName }}</h3>
          <div class="dot">&middot;</div>
          <h3 [ngStyle]="{fontSize:fontSize}">
            {{ loanOfficer$.companyName }}</h3>
        </div>
      </div>
    </div>
    <div class="header-logo">
      <div class="header-logo-img">
        <div class="img-container"
          [ngStyle]="{'background-image': 'url(' + loanOfficer$.companyLogoUrl + ')','background-size': 'contain','max-width':'96pt'}">
        </div>
      </div>
    </div>
  </header>
 
  <table  class="supporting-docs-table">
    <thead>
      <tr>
        <td>
          <div class="header-space">&nbsp;</div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <main>
            <ng-container *ngFor="let asset of loanOfficer$.assetArray">
             <ng-container>
                 <section >
                  <h2>Supporting Documents</h2>
                  <!-- <h5>{{ asset.alternateName != '' && asset.alternateName != null ? asset.alternateName : asset.assetTypeName }}</h5> -->
                  <div class="document-wrapper">
                    <img [src]="asset" alt="custom documents">
                  </div>
                </section>
              </ng-container>
            </ng-container>
          </main>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>
          <div class="footer-space">&nbsp;</div>
        </td>
      </tr>
    </tfoot>
  </table>
  <footer  [style.backgroundColor]="loanOfficer$.footerColor"
  class="footer">
  <ul class="footer-info">
    <li>
      {{ loanOfficer$.firstName }} {{ loanOfficer$.lastName }}, {{ loanOfficer$.phoneNumber }},
      <a href="mailto:{{ loanOfficer$.email }}">{{ loanOfficer$.email }}</a>
    </li>
    <li *ngIf="loanOfficer$.officeAddress">{{ loanOfficer$.officeAddress }}</li>
    <li *ngIf="loanOfficer$.website"><a href="{{ loanOfficer$.website }}">{{ loanOfficer$.website }}</a></li>
  </ul>
</footer>
</ng-container>